export function disablePluginsToBundle(pluginsSettings, pluginsData) {
    return {
        id: pluginsSettings.id,
        filters: pluginsSettings.filters,
        rules: pluginsSettings.content.map(plugin => disabledPluginValueToRule(plugin, pluginsData))
    };
}
export function pluginRuleBundleToDisablePlugins(bundle, tools) {
    var _a;
    return {
        id: (_a = bundle.id) !== null && _a !== void 0 ? _a : crypto.randomUUID(),
        filters: bundle.filters,
        tools,
        content: bundle.rules
            .filter((rule) => rule.type === 'single-plugin')
            .filter(rule => rule.action === 'disable' || rule.action === 'force-restrict')
            .map(rule => ruleToDisabledPluginValue(rule))
    };
}
function disabledPluginValueToRule(pluginValue, pluginsData) {
    const pluginModel = pluginsData.get(pluginValue.pluginId);
    return {
        type: 'single-plugin',
        action: pluginValue.forced ? 'force-restrict' : 'disable',
        singlePluginTypeRule: mapPluginModelToRuleType(pluginValue, pluginModel)
    };
}
function ruleToDisabledPluginValue(rule) {
    return {
        pluginId: rule.singlePluginTypeRule.pluginDefinition.id,
        forced: rule.action === 'force-restrict'
    };
}
function mapPluginModelToRuleType(pluginValue, model) {
    if (!model) {
        return {
            type: 'internal-repo',
            pluginDefinition: { id: pluginValue.pluginId }
        };
    }
    switch (model === null || model === void 0 ? void 0 : model.source) {
        case 'MARKETPLACE': {
            return {
                type: 'marketplace',
                pluginDefinition: { id: model.key, name: model.label },
                version: { type: 'all' }
            };
        }
        case 'TBE': {
            return {
                type: 'internal-repo',
                pluginDefinition: { id: model.key, name: model.label },
                version: { type: 'all' }
            };
        }
        case 'BUNDLED': {
            return {
                type: 'bundled',
                pluginDefinition: { id: model.key, name: model.label }
            };
        }
        default: {
            return assert_exhaustive(model.source);
        }
    }
}
